import * as React from "react"
import { Widget, mk_widget, any } from "widgets-for-react"
import { compositionOverlayVideoLibrary, compositionVideoLibrary } from "./compositions/videoLibrary"
import { StyleguideChapter, StyleguidePart, StyleguideSection } from "./helpers"


export const styleguideCompositions: Widget<never> = mk_widget({
  run: (_) => (
    <>
      {StyleguideChapter({ title: "Video library" })(
        StyleguideSection({ title: "", slug: "compositions-library" })(
          any()([
            StyleguidePart({ title: "Video library page", intro: "", isFullScreen: false })(
              mk_widget({
                run: (_) => <>{compositionVideoLibrary.run(_)}</>,
              })
            ),
            StyleguidePart({ title: "Video library - overlay open", intro: "", isFullScreen: true })(
              mk_widget({
                run: (_) => <>{compositionOverlayVideoLibrary.run(_)}</>,
              })
            ),
          ])
        )
      ).run(_)}
    </>
  ),
})



// WEBPACK FOOTER //
// ./Client/styleguide/components/compositions.tsx